var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rerender)?_c('v-chart',{staticClass:"age-group-chart",attrs:{"options":_vm.chartOptions,"autoresize":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }